import AgendaDay from './AgendaDay'

export default AgendaDay
